import { StreamWidgetOptions } from '../types';

export default function checkIsMatchTrackerDisabled(
    disableMatchTracker: StreamWidgetOptions['disableMatchTracker'] | undefined,
    sportId: string | undefined
): boolean {
    if (typeof disableMatchTracker === 'boolean') return disableMatchTracker;
    if (!sportId || !disableMatchTracker) return false;

    return disableMatchTracker.includes(sportId);
}
